import InitReducer from './init_reducer';
import ViewStateReducer from './view_state_reducer';
import RequestStateReducer from './request_state_reducer';
import ItineraryReducer from './itinerary_reducer';
import LocaleReducer from './locale_reducer';
import MemberReducer from './member_reducer';
import TripListReducer from './trip_list_reducer';
import collections from './collectionsReducer';
import RunTimeVariablesReducer from './run_time_variables_reducer';
import RecommendedPoiListReducer from './recommended_poi_list_reducer';
import CityAutoCompleteReducer from './city_auto_complete_reducer';
import journal from '../pages/journal/reducer'; // TODO: 待修正 =_=
import itineraryCollectionsReducer from './itinerary_collections_reducer'; // TODO: 待修正 HACK: 待修正 =_=
import notification from './notification';
import myTripList from './myTripListReducer';
import groupTripList from './groupTripListReducer';
import discover from './discoverReducer';
import article from './articleReducer';
import searchList from './searchReducer';
import profile from './profile';
import photoGallery from './photoGallery';
import poiDetail from './poiDetail';
import ec from './ec';
import experiences from './experiences';
import apiEcStatus from './apiEcStatus';
import apiFunlidayStatus from './apiFunlidayStatus';
import apiJournalStatus from './apiJournalStatus';
import apiCollectionStatus from './apiCollectionStatus';
import myJournals from './myJournals';
import cars from './cars';
import myReferral from './myReferral';
import rewardPointsReducer from './rewardPointsReducer';

const rootReducer = {
  init: InitReducer,
  viewState: ViewStateReducer,
  requestState: RequestStateReducer,
  itinerary: ItineraryReducer,
  itineraryCollection: itineraryCollectionsReducer,
  internationalize: LocaleReducer,
  member: MemberReducer,
  tripList: TripListReducer,
  collections,
  runtimeVariables: RunTimeVariablesReducer,
  poiList: RecommendedPoiListReducer,
  cityAutoComplete: CityAutoCompleteReducer,
  journal,
  notification,
  myTripList,
  groupTripList,
  discover,
  article,
  searchList,
  profile,
  photoGallery,
  poiDetail,
  ec,
  experiences,
  apiEcStatus,
  apiFunlidayStatus,
  apiJournalStatus,
  apiCollectionStatus,
  myJournals,
  cars,
  myReferral,
  rewardPoints: rewardPointsReducer
};

export default rootReducer;
